const typography = {
  fontFamily: 'Sora, sans-serif',
  fontWeightBold: 700,
  fontWeightLight: 300,
  fontWeightMedium: 500,
  fontWeightRegular: 400,
  body1: {
    fontSize: '0.875rem',
    lineHeight: 1.65,
  },
  body2: {
    fontSize: '0.75rem',
    lineHeight: 1.65,
  },
  h1: {
    fontSize: '1.875rem',
    lineHeight: 1.25,
    fontWeight: 600,
  },
  h2: {
    fontSize: '1.5rem',
    lineHeight: 1.25,
    fontWeight: 400,
  },
  h3: {
    fontSize: '1.25rem',
    lineHeight: 1.25,
    fontWeight: 400,
  },
  h4: {
    fontSize: '1rem',
    lineHeight: 1.25,
    fontWeight: 400,
  },
  h5: {
    fontSize: '0.875rem',
    lineHeight: 1.25,
    fontWeight: 600,
  },
  h6: {
    fontSize: '0.75rem',
    lineHeight: 1.25,
    fontWeight: 600,
  },
  subtitle1: {
    fontSize: '0.875rem',
    lineHeight: 1.25,
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: '0.75rem',
    lineHeight: 1.25,
    fontWeight: 400,
  },
  caption: {
    fontSize: '0.875rem',
    lineHeight: 1.25,
    fontWeight: 600,
  },
  overline: {
    fontSize: '0.625rem',
    lineHeight: 1.25,
    fontWeight: 600,
  },
  button: {
    fontSize: '0.75rem',
    lineHeight: 1.25,
    fontWeight: 600,
    textTransform: 'none' as const,
  },
};

export default typography;
